const initialState = {
    current: null,
    list: false,
    loaded: false,
};

export default function (state = initialState, action) {
    const { payload, type } = action;

    switch (type) {
        case "LOAD_EVENTS": {
			let currentEvent = localStorage.getItem('adminCurrentEvent');

			if(currentEvent) {
				currentEvent = JSON.parse(currentEvent);
                currentEvent = payload.find(event => event.id === currentEvent);
			}

            return {
                ...state,
                list: payload,
                loaded: true,
                current: currentEvent,
            };
        }

		case "SET_CURRENT_EVENT": {
			localStorage.setItem('adminCurrentEvent', JSON.stringify(payload));

			return {
				...state,
				current: state.list.find(event => event.id === payload)
			}
        }

        case "UPDATE_EVENT": {
            return {
                ...state,
                current: state.current.id === payload.id ? {...state.current, ...payload} : state.current,
                list: state.list.map(event => {
                    if(event.id === payload.id) return payload
                    else return event
                })
            }
        }
        
        default:
            return state;
    }
}
